export { default } from './AboutMaterialDownload';



// WEBPACK FOOTER //
// ./src/components/AboutMaterialDownload/index.js